export default "__VITE_PUBLIC_ASSET__7712b39a__"